import React, { ReactNode } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from '@mui/material';
import { StyledButton, modalStyles } from './styles';

interface CustomModalProps {
  isOpen: boolean;
  title: string;
  text?: string;
  firstButtonAction: () => void;
  secondButtonAction?: () => void;
  setIsOpen: (isOpen: boolean) => void;
  firstButtonLabel?: string;
  secondButtonLabel?: string;
  children?: ReactNode;
}

const CustomModal: React.FC<CustomModalProps> = ({
  isOpen,
  title,
  text,
  firstButtonAction,
  secondButtonAction,
  setIsOpen,
  firstButtonLabel = 'Aceptar',
  secondButtonLabel = 'Cancelar',
  children,
}) => {
  return (
    <Dialog
      open={isOpen}
      aria-labelledby="dialog"
    >
      <DialogTitle id="dialog" sx={modalStyles.dialogTitle}>
        <Typography align="center" sx={modalStyles.titleAlert}>
          {title}
        </Typography>
      </DialogTitle>

      <DialogContent sx={{ ...modalStyles.root, ...modalStyles.dialogContent }}>
        {text && (<DialogContentText dangerouslySetInnerHTML={{ __html: text }} />)}
        {/* {text && <DialogContentText>
          {text}
        </DialogContentText>} */}
        {children && children}
      </DialogContent>

      <DialogActions sx={modalStyles.dialogActions}>
        {secondButtonAction && (
          <StyledButton
            error
            autoFocus
            onClick={() => {
              secondButtonAction();
              setIsOpen(false);
            }}
          >
            {secondButtonLabel}
          </StyledButton>
        )}

        <StyledButton
          autoFocus
          onClick={() => {
            firstButtonAction();
            setIsOpen(false);
          }}
        >
          {firstButtonLabel}
        </StyledButton>
      </DialogActions>
    </Dialog>
  );
};

export default CustomModal;
